//natives
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import dateFormat from 'dateformat';
import $ from "jquery";
import TagManager from 'react-gtm-module';

//components
import PedidosLista from '../childrens/PedidosLista/.mixins/PedidosLista';
import CustomSort from '../childrens/customSort/.mixins';
import Columns from '../childrens/columns/.mixins';
import Modal from '../childrens/modal/.mixins';
import Alerta from '../../../../../util/snackbars/.mixins/';
import { AuthContext } from '../../../../../../contexts/AuthContext';

//constrollers
import OpcoesRecebimento_controller from '../../../../../../controllers/opcoesRecebimento';
import Config from '../../../../../../controllers/config';
import Log from '../../../../../../controllers/log';

export default class OpcoesRecebimento extends Component {
    static contextType = AuthContext;

    constructor(props) {
        super(props);

        this.child = React.createRef();
        this.inputRef = React.createRef();
        this.permissions = {};

        this.state = {
            title: "Opções de recebimento",
            itens: [],
            itensTable: [],
            columns: Columns,
            isLoading: true,
            isError: false,
            error: null,
            fontSize: '8pt',
            nameCSV: "Opcoes de recebimento",
            filters: {
                datas: false,
                flagsPag: false,
                adminFilter: false,
            },
            fornecedor: 0,
            openModel: false,
            open: false,
            descontoEscolhido: "",
            bodyEscolhido: {},
            listaDescontos: [],
            customSort: CustomSort
        }

        //binds
        this.setState = this.setState.bind(this);
        this.loadData = this.loadData.bind(this);
        this.handleOpenModel = this.handleOpenModel.bind(this);
        this.handleCloseModel = this.handleCloseModel.bind(this);
        this.handleClickOpen = this.handleClickOpen.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.sendForm = this.sendForm.bind(this);
        this.loadDescontos = this.loadDescontos.bind(this);
    }

    handleClickOpen = () => {
        this.setState({open:true});
    };

    handleClose = () => {
        this.setState({open:false});
    };

    handleOpenModel() {
        this.setState({
            openModel: true,
        });
    }

    handleCloseModel() {
        this.setState({openModel: false});
    }

    handleChange = (event) => {
        this.setState({descontoEscolhido: event.target.value});
    };

    validacoes() {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            //validações
            if (this.state.descontoEscolhido == null || this.state.descontoEscolhido == "")
                throw new Error("Escolha uma opção!");

            return true;

        } catch (error) {
            this.child.current.retorno(error.message,'warning');

            //auditoria
            const str = `Erro na recuperação de dados de pedidos! 
            Error:( Message: ${error.message}, Stack: ${error.stack} )`;
            Log.warning(token,str);

            return false;
        }
    }

    sendForm = async () => {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        if (!this.validacoes())
            return;

        try {

            this.handleCloseModel();
            this.setState({isLoading:true});

            const body = {
                ...this.state.bodyEscolhido,
                cd_pagto: parseInt(this.state.descontoEscolhido)
            };

            const r_antecipacao = await OpcoesRecebimento_controller.put(token,body);
            const j_r_antecipacao = JSON.parse(r_antecipacao.body);

            if (r_antecipacao.res.statusCode === 200) {
                const message = "Feito escolha de antecipação!";
                this.setState({isLoading: false});
                this.child.current.retorno(message,'success');
                setTimeout(() => {
                    this.handleCloseModel();
                    this.loadData();
                }, 1000);

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:opcoes-recebimento',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso:${message}`,
                //     }
                // });
            } else {
                if (
                    j_r_antecipacao.status == false &&
                    j_r_antecipacao.message &&
                    j_r_antecipacao.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else if (
                    j_r_antecipacao.status == false &&
                    j_r_antecipacao.message &&
                    (
                        j_r_antecipacao.message.includes("Campos necessários") ||
                        j_r_antecipacao.message.includes("Permissão")
                    )
                ) {
                    throw new Error(j_r_antecipacao.message);
                } else {
                    throw new Error("O ocorreu um erro no sistema!");
                }
            }

            //auditoria
            const str = `Efetuada requisição para recuperação de dados de antecipacao! 
            Response:( Method: ${r_antecipacao.res.request.method}, 
            StatusCode: ${r_antecipacao.res.statusCode}, 
            Body: (limited 100chars)${r_antecipacao.body.substr(0,100)} )`;
            Log.info(token,str);
        } catch (error) {
            this.child.current.retorno('Erro ao carregar dados!','error');
            let errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            this.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });
            
            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:opcoes-recebimento',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });

            //auditoria
            const str = `Erro na recuperação de dados de antecipacao! 
            Error:( Message: ${error.message}, Stack: ${error.stack} )`;
            Log.error(token,str);
        }
    };

    UNSAFE_componentWillMount() {
        this.permissions = this.context.user.permissions;
        
        this.setState({
            filters: {
                ...this.state.filters,
                adminFilter: !!this.permissions["filtro-fornecedor"],
            }
        });
        
        this.loadData(null);
        this.setState({
            onRowClick: (rowData, rowMeta) => {
                const bodyEscolhido = {
                    id_pessoa: this.state.fornecedor,
                    nr_pc: rowData[0],
                    cd_fil: rowData[1],
                    id_prod: rowData[3],
                    dt_entrg: rowData[2],
                    qt_entrg: rowData[8],
                };
                this.setState({bodyEscolhido, descontoEscolhido: rowData[16].toString()});
                this.handleOpenModel();

                TagManager.dataLayer({
                    dataLayer: {
                        event: 'event',
                        eventCategory: 'tokstok:fornecedores:pagamentos',
                        eventAction: 'clique:pedido',
                        eventLabel: `${rowData[0]}`
                    }
                });
            },
        });
    }

    componentDidMount() {
        // TagManager.dataLayer({
        //     dataLayer: {
        //       event: 'event',
        //       eventCategory: 'tokstok:fornecedores:opcoes-recebimento',
        //       eventAction: 'componentDidMount',
        //       eventLabel: 'componente-opcoes-recebimento',
        //     }
        // });

        //auditoria
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        Log.info(token,`Efetuado carregamento da tela Consulta Pedidos ${this.state.title}!`);

        $(document).ready(() => {
            setTimeout(() => {
                $($("tbody")).css('cursor','pointer');
            }, 2000);
            setTimeout(() => {
                $($("tbody")).css('cursor','pointer');
            }, 3000);
            setTimeout(() => {
                $($("tbody")).css('cursor','pointer');
            }, 4000);
        });
    }

    UNSAFE_componentWillReceiveProps() {
        this.setState({
            title: this.state.title,
        });
        this.loadData(null);
    }

    async loadData(filters) {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        this.loadDescontos(null);
        try {

            let r_pedidos = null;
            let j_r_pedidos = null;
            this.setState({isLoading:true});
            
            //define filtros
            const filters = {
                idFornecedor: this.state.fornecedor
            };
            r_pedidos = await OpcoesRecebimento_controller.getAll(token,filters);
            j_r_pedidos = JSON.parse(r_pedidos.body);

            if (r_pedidos.res.statusCode === 200) {
                this.setState({
                    itens: j_r_pedidos
                });
                let array = [];
                j_r_pedidos.forEach(element => { 

                    const dt_entrg = (element.DT_ENTRG == null)?"":element.DT_ENTRG.split(' ')[0];
                    const dt_emis = (element.DT_EMIS == null)?"":element.DT_EMIS.split(' ')[0];
                    const dt_prev_entrg = (element.DT_PREV_ENTRG == null)?"":element.DT_PREV_ENTRG.split(' ')[0];
                    const dt_solic_antec = (element.DT_SOLIC_ANTEC == null)?"":element.DT_SOLIC_ANTEC.split(' ')[0];
                    const arrayPush = {
                        ...element,
                        DT_ENTRG: dt_entrg,
                        DT_EMIS: dt_emis,
                        DT_SOLIC_ANTEC: dt_solic_antec,
                        DT_PREV_ENTRG: dt_prev_entrg
                    };
                    array.push(arrayPush);
                });
                this.setState({
                    itensTable: array,
                    isLoading: false
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:opcoes-recebimento',
                //       eventAction: 'callback',
                //       eventLabel: 'sucesso:lista-opcoes-recebimento',
                //     }
                // });
            } else {
                if (
                    j_r_pedidos.status == false &&
                    j_r_pedidos.message &&
                    j_r_pedidos.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(function() {
                        window.location.reload();
                    }, 1000);
                } else if (
                    j_r_pedidos.status == false &&
                    j_r_pedidos.message &&
                    (
                        j_r_pedidos.message.includes("Campos necessários") ||
                        j_r_pedidos.message.includes("Permissão")
                    )
                ) {
                    throw new Error(j_r_pedidos.message);
                } else {
                    throw new Error("O ocorreu um erro no sistema!");
                }
            }

            //auditoria
            const str = `Efetuada requisição para recuperação de dados de pedidos! 
            Response:( Method: ${r_pedidos.res.request.method}, 
            StatusCode: ${r_pedidos.res.statusCode}, 
            Body: (limited 100chars)${r_pedidos.body.substr(0,100)} )`;

            Log.info(token,str);
        } catch (error) {
            this.child.current.retorno('Erro ao carregar dados!','error');
            let errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE") 
                errorString = error.message;
            this.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:opcoes-recebimento',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });

            //auditoria
            const str = `Erro na recuperação de dados de pedidos! 
            Error:( Message: ${error.message}, Stack: ${error.stack} )`;
            Log.error(token,str);
            console.error(error.message);
        }

    }

    async loadDescontos(filter) {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {

            this.setState({isLoading:true});

            //define filtros
            const filters = {
                idFornecedor: this.state.fornecedor
            };
            const r_descontos = await OpcoesRecebimento_controller.getDescontos(token,filters);
            let j_r_descontos = JSON.parse(r_descontos.body);
            
            if(j_r_descontos.length === 1 && 
               j_r_descontos[0].IN_COND_PADRAO_FORNEC =="S"){
                j_r_descontos = [];
            }
            
            if (r_descontos.res.statusCode === 200) {
                this.setState({
                    listaDescontos: j_r_descontos,
                    isLoading: false
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:opcoes-recebimento',
                //       eventAction: 'callback',
                //       eventLabel: 'sucesso:lista-descontos',
                //     }
                // });
            } else {
                if (
                    j_r_descontos.status == false &&
                    j_r_descontos.message &&
                    j_r_descontos.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else if (
                    j_r_descontos.status == false &&
                    j_r_descontos.message &&
                    (
                        j_r_descontos.message.includes("Campos necessários") ||
                        j_r_descontos.message.includes("Permissão")
                    )
                ) {
                    throw new Error(j_r_descontos.message);
                } else {
                    throw new Error("O ocorreu um erro no sistema!");
                }
            }

            //auditoria
            const str = `Efetuada requisição para recuperação de dados de descontos! 
            Response:( Method: ${r_descontos.res.request.method}, 
            StatusCode: ${r_descontos.res.statusCode}, 
            Body: (limited 100chars)${r_descontos.body.substr(0,100)} )`;
            Log.info(token,str);
        } catch (error) {
            this.child.current.retorno('Erro ao carregar dados!','error');
            let errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            this.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:opcoes-recebimento',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });

            //auditoria
            const str = `Erro na recuperação de dados de descontos! 
            Error:( Message: ${error.message}, Stack: ${error.stack} )`;
            Log.error(token,str);
        }

    }

    convStringDate(dateString) {
        const dateParts = dateString.split("/");
        return new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
    }

    async loadDataAgendamentos(props) {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        try {
            let r_datas = await Pedidos_controller.getDataAgendamentos(token);
            let j_r_datas = JSON.parse(r_datas.body);

            if (r_datas.res.statusCode === 200) {
                let array = [];
                j_r_datas.itens.forEach(element => {
                    array.push(new Date(dateFormat(new Date(element),'yyyy-mm-dd')+' 00:00:00'));
                });
                props.setState({
                    dataAgendamentos: array,
                    isLoading: false
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:opcoes-recebimento',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso:lista-agendados`,
                //     }
                // });
            } else {
                if (
                    j_r_datas.status == false &&
                    j_r_datas.message &&
                    j_r_datas.message.includes("Token inválido!")
                ) {
                    props.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(function() {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }

            //auditoria
            const str = `Efetuada requisição para recuperação de Datas para agendamento! 
            Response:( Method: ${r_datas.res.request.method}, 
            StatusCode: ${r_datas.res.statusCode}, 
            Body: (limited 100chars)${r_datas.body.substr(0,100)} )`;
            Log.info(token,str);
        } catch (error) {
            props.child.current.retorno('Erro ao carregar dados!','error');
            let errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:opcoes-recebimento',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });

            //auditoria
            const str = `Erro na recuperação de Datas para agendamento! 
            Error:( Message: ${error.message}, Stack: ${error.stack} )`;
            Log.error(token,str);
        }

    }

    render() {
        return(
            <div>
                <PedidosLista {...this}/>
                <br/>
                <Alerta ref={this.child}/>
                <Modal {...this}/>
            </div>
        );
    }

}